import * as Sentry from '@sentry/browser'
import { Button, Col, Input } from 'antd'
import React, { useEffect, useState } from 'react'
import Card from 'components/Card'
import { CloudDownloadOutlined } from '@ant-design/icons'
import { fetchAuthSession } from 'aws-amplify/auth'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import CutContainerTable, { exportCutContainers } from './CutContainerTable'

import './cutContainerTable.less'

const CutContainer = () => {
  const { t } = useTranslation()
  const { portCallId } = useParams()
  const [containers, setContainers] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    let isMounted = true

    const fetchCutContainers = async () => {
      setIsLoading(true)

      try {
        const { tokens } = await fetchAuthSession()
        const response = await Sentry.startSpan(
          { name: 'cut-container', op: 'http.client' },
          () =>
            fetch(`${process.env.BACK_END_URL}/cut-container?portCallId=${portCallId}`, {
              headers: {
                Authorization: tokens.idToken.toString(),
                'cargomate-request-id': crypto.randomUUID(),
                source: 'web-dashboard',
              },
            })
        )
        if (!response.ok) throw new Error('Failed to fetch cut containers')
        const data = await response.json()

        if (isMounted)
          setContainers(Array.isArray(data) ? data : data.items || [])
      } finally {
        if (isMounted) setIsLoading(false)
      }
    }

    fetchCutContainers().catch(() => {
      if (isMounted) setContainers([])
    })

    return () => {
      isMounted = false
    }
  }, [portCallId])

  return (
    <Col xs={24}>
      <Card
        title={
          <div className="cut-container__header">
            <Input
              allowClear
              className="cut-container__search"
              onChange={event => setSearchTerm(event.target.value)}
              placeholder={t('portCall.cutContainerSearchPlaceholder')}
              value={searchTerm}
            />
            <Button
              disabled={containers.length === 0}
              icon={<CloudDownloadOutlined />}
              onClick={() => exportCutContainers(containers)}
              size="small"
              type="primary"
            >
              {t('portCall.cutContainerDownloadButton')}
            </Button>
          </div>
        }
      >
        <CutContainerTable
          containers={containers}
          isLoading={isLoading}
          searchTerm={searchTerm}
        />
      </Card>
    </Col>
  )
}

export default CutContainer
